import type { CategoryPermissionResponse } from '@/shared/types'
import http from '../../api/http'
import type { ApiResponse } from '../../api/http/api/response.api'
import { apiGetListTab, apiGetMenu } from './components/urls'

export interface MenuItemResponse {
  id: string
  label: string
  routerLink?: string | null
  icon?: string | null
  parentItemId?: string | null
  order: number
  isGroup: boolean
  status: boolean
  categoryID?: number | null
  categoryName?: string | null
  children: MenuItemResponse[]
}

const getListTab = (): Promise<ApiResponse<CategoryPermissionResponse[]>> => http.get(apiGetListTab)

const getMenu = (): Promise<ApiResponse<MenuItemResponse[]>> => http.get(apiGetMenu)

const roleSystemService = { getListTab, getMenu }
export default roleSystemService
